import { render, staticRenderFns } from "./NotifMentionInPost.vue?vue&type=template&id=1ea99b7f&scoped=true"
import script from "./NotifMentionInPost.vue?vue&type=script&lang=js"
export * from "./NotifMentionInPost.vue?vue&type=script&lang=js"
import style0 from "./NotifStyle.scss?vue&type=style&index=0&id=1ea99b7f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea99b7f",
  null
  
)

export default component.exports